export function parseApiAmount(amount: number | string): string {
	if (typeof amount === 'string') {
		return (parseFloat(amount) * 100).toString();
	}

	return (amount * 100).toString();
}

export function formatApiAmount(amount: number | string): number {
	if (typeof amount === 'string') {
		return parseFloat(amount) / 100;
	}

	return amount / 100;
}
